import React, { Component } from "react";
import {
  Grid,
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import Progress from "./CustomTool/Progress";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtDtp from "./CustomTool/CtDtp";
import MaterialUIPickers from "./CustomTool/CtDtpTime";
import dayjs from "dayjs";

import {
  applyTrimOnObjectValues,
  isValidItem,
} from "../SystemUtility/SystemUtility";
import { fetchGSTInfo, fetchSales } from "./API";
import ControlledCheckbox from "./CustomTool/CtCheckBox";
import { Info } from "@mui/icons-material";

class SalesE_WayBill extends Component {
  state = {
    formData: {
      bint_salessrno:
        Number(this.props.bint_salessrno) > 0 ? this.props.bint_salessrno : 0,
      txtEWaybill: "",
      DtpEWaybillDate: dayjs().format("DD/MM/YYYY hh:mm A"),
      txtSupplyType: "Outward",
      txtsubtype:
        this.props.SubSupplyType.length > 0 ? this.props.SubSupplyType : "",
      cmbSubTypeOtherSpecify: "",
      CmbDocumentType: "",
      txtDocumentNo:
        Number(this.props.DocumentNo) > 0 ? this.props.DocumentNo : "",
      dtpDocumentDate:
        this.props.DocumentDate.length > 0 ? this.props.DocumentDate : "",
      cmbTransactionType: "",
      txtDispatchAddress1:
        this.props.CompanyDetails.length > 0
          ? this.props.CompanyDetails[0].vac_address
          : "",
      txtDispatchAddress2: "",
      CmbDispatchPlace:
        this.props.CompanyDetails.length > 0
          ? this.props.CompanyDetails[0].vac_city
          : "",
      txtDispatchPincode:
        this.props.CompanyDetails.length > 0
          ? this.props.CompanyDetails[0].vac_pincode
          : "",
      CmbDispatchState:
        this.props.CompanyDetails.length > 0
          ? this.props.CompanyDetails[0].vac_state
          : "",
      txtCompanyStateCode:
        this.props.CompanyDetails.length > 0
          ? this.props.CompanyDetails[0].vac_statecode
          : "",
      txtCustomerName:
        this.props.CustomerData && this.props.CustomerData.vac_customer != null
          ? this.props.CustomerData.vac_customer
          : "",
      txtCustomerGSTNO:
        this.props.CustomerData && this.props.CustomerData.vac_gstin != null
          ? this.props.CustomerData.vac_gstin
          : "",
      txtShipToAddress1:
        this.props.CustomerData && this.props.CustomerData.vac_address != null
          ? this.props.CustomerData.vac_address
          : "",
      txtShipToAddress2: "",
      CmbShipToPlace:
        this.props.CustomerData && this.props.CustomerData.vac_city != null
          ? this.props.CustomerData.vac_city
          : "",
      txtShipToPincode:
        this.props.CustomerData && this.props.CustomerData.vac_pincode != null
          ? this.props.CustomerData.vac_pincode
          : "",
      CmbShipToState:
        this.props.CustomerData && this.props.CustomerData.vac_state != null
          ? this.props.CustomerData.vac_state
          : "",
      txtCustomerStateCode:
        this.props.CustomerData && this.props.CustomerData.vac_statecode != null
          ? this.props.CustomerData.vac_statecode
          : "",
      totalAfterTaxAmt:
        Number(this.props.totalAfterTaxAmt) > 0
          ? this.props.totalAfterTaxAmt
          : "",
      txtHsnCode: this.props.HsnCode.length > 0 ? this.props.HsnCode : "",
      txtTotalValue: Number(this.props.Taxable) > 0 ? this.props.Taxable : "",
      txtTotalCGST: Number(this.props.CGST) > 0 ? this.props.CGST : "",
      txtTotalSGST: Number(this.props.SGST) > 0 ? this.props.SGST : "",
      txtTotalIGST: Number(this.props.IGST) > 0 ? this.props.IGST : "",
      txtTotalInvoiceValue:
        Number(this.props.GrandTotal) > 0 ? this.props.GrandTotal : "",
      CmbModeOfTransportation: "",
      txtApproximateDistance: "",
      CmbTransporterName: "",
      CmbTransporterID: "",
      txtTransporterDocNo: "",
      dtpTransporterDate: "",
      CmbVehicleNo: "",
      CmbVehicleType: "",
      chkGetPincodeDistance: true,
      txtEditDispatchPincode: "",
      txtEditShipToPincode: "",
    },
    DocumentType: [],
    SubSupplyTypeOther: [{ vac_subsupplytypeother: "vac_subsupplytypeother" }],
    TransactionType: [
      { vac_transtype: "Bill To - Ship To" },
      { vac_transtype: "Regular" },
    ],
    DispatchPlace: [],
    DispatchState: [],
    ShipToPlace: [],
    ShipToState: [],
    ModeofTransportation: [
      { vac_transmode: "Road" },
      { vac_transmode: "Rail" },
      { vac_transmode: "Air" },
      { vac_transmode: "Ship or Ship Cum Road/Rail" },
    ],
    TransporterName: [],
    TransporterID: [],
    VehicleNo: [],
    VehicleType: [
      { vac_vehicletype: "Regular" },
      { vac_vehicletype: "Over Dimensional Cargo" },
    ],
    ARD: null,
    openValidVehicleNoFormat: false,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Sales E-Way Bill";
    this.props.setActiveMenu("SalesEWayBill");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  onFormLoad = () => {
    let DocumentType = [],
      CmbDocumentType = "",
      cmbTransactionType = this.state.formData.cmbTransactionType;

    const supplyType = this.state.formData.txtsubtype;

    if (supplyType === "Supply") {
      DocumentType = [
        { vac_doctype: "Tax Invoice" },
        { vac_doctype: "Bill of Supply" },
      ];
      CmbDocumentType = "Tax Invoice";
    } else if (supplyType === "Export") {
      DocumentType = [
        { vac_doctype: "Tax Invoice" },
        { vac_doctype: "Bill of Supply" },
      ];
      CmbDocumentType = "Bill of Supply";
    } else if (
      ["Job Work", "For Own Use", "Exhibition", "Fairs", "Line Sales"].includes(
        supplyType
      )
    ) {
      DocumentType = [{ vac_doctype: "Delivery Challan" }];
      CmbDocumentType = "Delivery Challan";
    } else if (supplyType === "SKD/CKD/Lots") {
      DocumentType = [
        { vac_doctype: "Tax Invoice" },
        { vac_doctype: "Bill of Supply" },
        { vac_doctype: "Delivery Challan" },
      ];
      CmbDocumentType = "Delivery Challan";
    } else if (supplyType === "Recipient Not Known") {
      DocumentType = [
        { vac_doctype: "Delivery Challan" },
        { vac_doctype: "Others" },
      ];
      CmbDocumentType = "Delivery Challan";
    } else if (supplyType === "Others") {
      DocumentType = [{ vac_doctype: "Others" }];
      CmbDocumentType = "Delivery Challan";
    }

    if (this.props.Customer.length > 0 && this.props.ShipTo.length > 0) {
      cmbTransactionType = "Bill To - Ship To";
    } else if (this.props.Customer.length > 0) {
      cmbTransactionType = "Regular";
    }

    this.setState(
      {
        DocumentType,
        formData: {
          ...this.state.formData,
          CmbDocumentType,
          cmbTransactionType,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadEwayBillDetails",
        bint_salessrno: this.state.formData.bint_salessrno,
        bint_acid: this.props.bint_acid,
        bint_acyear: this.props.bint_acyear,
      };
      fetchSales(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let DispatchState = res.data.StateList,
            EWayBillData = res.data.EWayBillData,
            DispatchPlace = res.data.DispatchPlace,
            TransporterName = res.data.TransporterName,
            TransporterID = res.data.TransporterId,
            VehicleNo = res.data.VehicleNo,
            ShipToPlace = res.data.ToPlace;

          if (EWayBillData.length > 0) {
            this.setState({
              formData: {
                ...this.state.formData,
                bint_salessrno: EWayBillData[0].bint_salessrno,
                txtEWaybill: EWayBillData[0].vac_ewaybillno,
                DtpEWaybillDate:
                  EWayBillData[0].dat_ewayackdatetime == "0000-00-00"
                    ? dayjs().format("DD/MM/YYYY hh:mm A")
                    : EWayBillData[0].dat_ewayackdatetime,
                txtSupplyType: EWayBillData[0].vac_supplytype,
                txtsubtype: EWayBillData[0].vac_subsupplytype,
                cmbSubTypeOtherSpecify: EWayBillData[0].vac_subsupplytypeother,
                CmbDocumentType: EWayBillData[0].vac_doctype,
                txtDocumentNo: EWayBillData[0].vac_docno,
                dtpDocumentDate: EWayBillData[0].dat_docdate,
                cmbTransactionType: EWayBillData[0].vac_transtype,
                txtDispatchAddress1: EWayBillData[0].vac_fromaddr1,
                txtDispatchAddress2: EWayBillData[0].vac_fromaddr2,
                CmbDispatchPlace: EWayBillData[0].vac_fromplace,
                txtDispatchPincode: EWayBillData[0].vac_frompincode,
                txtEditDispatchPincode: EWayBillData[0].vac_frompincode,
                CmbDispatchState: EWayBillData[0].vac_fromstate,
                txtCompanyStateCode: EWayBillData[0].vac_fromstatecode,
                txtCustomerName: EWayBillData[0].vac_totrdname,
                txtCustomerGSTNO: EWayBillData[0].vac_togstin,
                txtShipToAddress1: EWayBillData[0].vac_toaddr1,
                txtShipToAddress2: EWayBillData[0].vac_toaddr2,
                CmbShipToPlace: EWayBillData[0].vac_toplace,
                txtShipToPincode: EWayBillData[0].vac_topincode,
                txtEditShipToPincode: EWayBillData[0].vac_topincode,
                CmbShipToState: EWayBillData[0].vac_tostate,
                txtCustomerStateCode: EWayBillData[0].vac_tostatecode,
                txtHsnCode: EWayBillData[0].vac_mainhsncode,
                txtTotalValue: EWayBillData[0].dec_totalvalue,
                txtTotalCGST: EWayBillData[0].dec_cgstvalue,
                txtTotalSGST: EWayBillData[0].dec_sgstvalue,
                txtTotalIGST: EWayBillData[0].dec_igstvalue,
                txtTotalInvoiceValue: EWayBillData[0].dec_totinvvalue,
                CmbModeOfTransportation: EWayBillData[0].vac_transmode,
                txtApproximateDistance: EWayBillData[0].dec_transdistance,
                CmbTransporterName: EWayBillData[0].vac_transportername,
                CmbTransporterID: EWayBillData[0].vac_transporterid,
                txtTransporterDocNo: EWayBillData[0].vac_transdocno,
                dtpTransporterDate: EWayBillData[0].dat_transdocdate,
                CmbVehicleNo: EWayBillData[0].vac_vehicleno,
                CmbVehicleType: EWayBillData[0].vac_vehicletype,
                chkGetPincodeDistance: false,
              },
              DispatchState,
              ShipToState: DispatchState,
              DispatchPlace,
              ShipToPlace,
              TransporterName,
              TransporterID,
              VehicleNo,
            });
          } else {
            this.setState({
              DispatchState,
              ShipToState: DispatchState,
              DispatchPlace,
              ShipToPlace,
              TransporterName,
              TransporterID,
              VehicleNo,
            });
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in getInfo.", error);
        });
    });
    // document.getElementById("dtpFromDate").focus();
  };

  distanceValidation = () => {
    let result = false;
    if (this.state.formData.txtDispatchPincode.length <= 0) {
      this.props.toastErrorMsg("Enter Dispatch Pincode", "txtDispatchPincode");
    } else if (
      this.state.formData.txtDispatchPincode.length > 0 &&
      this.state.formData.txtDispatchPincode.length < 6
    ) {
      this.props.toastErrorMsg(
        "Enter Valid Dispatch Pincode",
        "txtDispatchPincode"
      );
    } else if (this.state.formData.txtShipToPincode.length <= 0) {
      this.props.toastErrorMsg("Enter Ship To Pincode", "txtShipToPincode");
    } else if (
      this.state.formData.txtShipToPincode.length > 0 &&
      this.state.formData.txtShipToPincode.length < 6
    ) {
      this.props.toastErrorMsg(
        "Enter Valid Ship To Pincode",
        "txtShipToPincode"
      );
    } else {
      result = true;
    }
    return result;
  };

  getApproxDistance = () => {
    if (this.distanceValidation()) {
      this.props.notifyProcessing();
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "GetPincodeDistance",
          FromPincode: this.state.formData.txtDispatchPincode,
          ToPincode: this.state.formData.txtShipToPincode,
        };
        fetchGSTInfo(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let txtApproximateDistance = res.data.DistanceKM;
            this.props.updateProcessing(res.data.msgType, res.data.message);

            this.setState({
              formData: {
                ...this.state.formData,
                txtApproximateDistance,
              },
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getInfo.", error);
          });
      });
      document.getElementById("txtApproximateDistance").focus();
    }
  };

  //#endregion Component

  //#region handle

  handleOnChkChange = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
        txtApproximateDistance: e.target.checked
          ? ""
          : this.state.formData.txtApproximateDistance,
      },
    });
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (
          e.target.name == "txtDispatchPincode" ||
          e.target.name == "txtShipToPincode"
        ) {
          if (
            this.state.formData.txtDispatchPincode ==
              this.state.formData.txtEditDispatchPincode &&
            this.state.formData.txtShipToPincode ==
              this.state.formData.txtEditShipToPincode
          ) {
            this.setState({
              formData: {
                ...this.state.formData,
                chkGetPincodeDistance: false,
              },
            });
          } else {
            this.setState({
              formData: {
                ...this.state.formData,
                chkGetPincodeDistance: true,
                txtApproximateDistance: "",
              },
            });
          }
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  //#endregion handle

  //#region function
  validateEwayBillData = () => {
    let result = false;
    const regex =
      /^[A-Z]{2}\d{2}[A-Z]{1,3}\d{4}$|^[A-Z]{2}\d{6}$|^[A-Z]{3}\d{4}$|^[A-Z]{2}\d{3}[A-Z]{1}\d{4}$|^(DF|TM|BP|NP)[A-Z0-9]{6}$/i;

    // console.log('regex.test("12345")', regex.test("12345"));
    // console.log('regex.test("GJ04bJ1624")', regex.test("GJ04bJ1624"));
    // console.log('regex.test("GJ04A1624")', regex.test("GJ04A1624"));
    // console.log('regex.test("GJ041624")', regex.test("GJ041624"));
    // console.log('regex.test("GJA41624")', regex.test("GJA41624"));
    // console.log('regex.test("GJ041b1624")', regex.test("GJ041b1624"));
    // console.log('regex.test("GJ041bJ1624")', regex.test("GJ041bJ1624"));
    // console.log('regex.test("DFXXXXXX")', regex.test("DFXXXXXX"));
    // console.log('regex.test("TMXXXXXX")', regex.test("TMXXXXXX"));
    // console.log('regex.test("NPXXXXXX")', regex.test("NPXXXXXX"));

    if (
      this.state.formData.cmbSubTypeOtherSpecify.length <= 0 &&
      this.state.formData.txtsubtype == "Others"
    ) {
      this.props.toastErrorMsg(
        "Select Sub Type Other Specify",
        "cmbSubTypeOtherSpecify"
      );
    } else if (this.state.formData.CmbDocumentType.length <= 0) {
      this.props.toastErrorMsg("Select Document Type", "CmbDocumentType");
    } else if (
      !isValidItem(
        this.state.DocumentType,
        "vac_doctype",
        this.state.formData.CmbDocumentType
      )
    ) {
      this.props.toastErrorMsg("Select Valid Document Type", "CmbDocumentType");
    } else if (this.state.formData.cmbTransactionType.length <= 0) {
      this.props.toastErrorMsg("Select Transaction Type", "cmbTransactionType");
    } else if (this.state.formData.txtDispatchPincode.length <= 0) {
      this.props.toastErrorMsg("Enter Dispatch Pincode", "txtDispatchPincode");
    } else if (this.state.formData.CmbDispatchState.length <= 0) {
      this.props.toastErrorMsg("Select Dispatch State", "CmbDispatchState");
    } else if (
      !isValidItem(
        this.state.DispatchState,
        "vac_state",
        this.state.formData.CmbDispatchState
      )
    ) {
      this.props.toastErrorMsg(
        "Select Valid Dispatch State",
        "CmbDispatchState"
      );
    } else if (this.state.formData.txtShipToPincode.length <= 0) {
      this.props.toastErrorMsg("Enter Ship To Pincode", "txtShipToPincode");
    } else if (this.state.formData.CmbShipToState.length <= 0) {
      this.props.toastErrorMsg("Select Ship To State", "CmbShipToState");
    } else if (
      !isValidItem(
        this.state.ShipToState,
        "vac_state",
        this.state.formData.CmbShipToState
      )
    ) {
      this.props.toastErrorMsg("Select Valid Ship To State", "CmbShipToState");
    } else if (this.state.formData.CmbModeOfTransportation.length <= 0) {
      this.props.toastErrorMsg(
        "Select Mode Of Transportation",
        "CmbModeOfTransportation"
      );
    } else if (
      !isValidItem(
        this.state.ModeofTransportation,
        "vac_transmode",
        this.state.formData.CmbModeOfTransportation
      )
    ) {
      this.props.toastErrorMsg(
        "Select Valid Mode Of Transportation",
        "CmbModeOfTransportation"
      );
    } else if (
      Number(this.state.formData.txtApproximateDistance) <= 0 &&
      this.state.formData.chkGetPincodeDistance == false
    ) {
      this.props.toastErrorMsg(
        "Enter Approximate Distance",
        "txtApproximateDistance"
      );
    } else if (
      this.state.formData.CmbModeOfTransportation === "Road" &&
      this.state.formData.CmbVehicleNo.length <= 0 &&
      this.state.formData.CmbTransporterID.length <= 0
    ) {
      this.props.toastErrorMsg("Select Transporter ID", "CmbTransporterID");
    } else if (
      (this.state.formData.CmbModeOfTransportation === "Rail" ||
        this.state.formData.CmbModeOfTransportation === "Air") &&
      this.state.formData.txtTransporterDocNo.length <= 0
    ) {
      this.props.toastErrorMsg(
        "Enter Transporter Document No",
        "txtTransporterDocNo"
      );
    } else if (
      (this.state.formData.CmbModeOfTransportation === "Rail" ||
        this.state.formData.CmbModeOfTransportation === "Air") &&
      this.state.formData.dtpTransporterDate.length <= 0
    ) {
      this.props.toastErrorMsg("Enter Transporter Date", "dtpTransporterDate");
    } else if (
      this.state.formData.CmbModeOfTransportation === "Road" &&
      !this.state.formData.txtTransId &&
      this.state.formData.CmbVehicleNo.length <= 0
    ) {
      this.props.toastErrorMsg("Select Vehicle No", "CmbVehicleNo");
    } else if (
      this.state.formData.CmbVehicleNo.length > 0 &&
      regex.test(this.state.formData.CmbVehicleNo) == false
    ) {
      this.props.toastErrorMsg("Enter Valid Vehicle No", "CmbVehicleNo");
    } else if (
      this.state.formData.CmbModeOfTransportation === "Road" &&
      this.state.formData.CmbVehicleType.length <= 0
    ) {
      this.props.toastErrorMsg("Select Vehicle Type", "CmbVehicleType");
    } else {
      result = true;
    }
    return result;
  };

  // saveEWayBill = () => {
  //   if (this.validateEwayBillData()) {
  //     alert("E Way Generate");
  //   }
  // };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkGetPincodeDistance"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  saveEWayBill = (copyToClipBoard) => {
    if (this.props.userPrivilege.Sales != "R") {
      this.trimFormData(() => {
        if (this.validateEwayBillData()) {
          const dataLoadStatus = false;
          this.props.notifyProcessing();
          this.setState({ dataLoadStatus }, () => {
            const reqData = {
              Op: "SaveSales_Item",
              bint_acyear: this.props.bint_acyear,
              bolinvoiceprint: false,
              bint_acid: this.props.bint_acid,
              vac_company: this.props.CompanyDetails[0].vac_company,
              bint_ci: localStorage.getItem("CI"),
              vac_username: localStorage.getItem("UserName"),
              bint_salessrno: this.state.formData.bint_salessrno,
              // bint_salessrno: this.props.edit_salessrno,
              dat_salesdate: this.props.dat_salesdate,
              vac_billtype: this.props.vac_billtype,
              vac_billno: this.props.vac_billno,
              bint_billno: this.state.formData.txtDocumentNo,
              vac_customer: this.props.Customer,
              vac_customershipto: this.props.ShipTo,
              vac_referencename: this.props.vac_referencename,
              dec_discamt: this.props.dec_discamt,
              dec_taxable: this.state.formData.txtTotalValue,
              dec_cgst: this.state.formData.txtTotalCGST,
              dec_sgst: this.state.formData.txtTotalSGST,
              dec_igst: this.state.formData.txtTotalIGST,
              dec_grtotal: this.state.formData.txtTotalInvoiceValue,
              dec_tdsamount: this.props.dec_tdsamount,
              dec_advancepayment: this.props.dec_advancepayment,
              dec_roundoff: this.props.dec_roundoff,
              dec_netpayment: this.props.dec_netpayment,
              vac_salestransactiontype: this.props.vac_salestransactiontype,
              bint_vouno: 0,
              vac_remark: this.props.vac_remark,
              dec_beforetaxamt: this.props.dec_beforetaxamt,
              dec_aftertaxamt: this.props.dec_aftertaxamt,
              PaymentData:
                this.props.cmbTransactionType == "Paid"
                  ? this.props.PaymentData
                  : [],
              OtherDetailData: this.props.OtherDetailData,
              dec_basicamt: this.props.txtbasicamt,
              totalafterDeductionTaxamt: this.props.totalafterDeductionTaxamt,
              totalAfteraddTaxamt: this.props.totalAfteraddTaxamt,
              totalBeforeaddTaxamt: this.props.totalBeforeaddTaxamt,
              totalBeforeDeductionTaxamt: this.props.totalBeforeDeductionTaxamt,
              EWayBillData: {
                vac_ewaybillno: this.state.formData.txtEWaybill,
                dat_ewayackdatetime: this.state.formData.DtpEWaybillDate,
                vac_supplytype: this.state.formData.txtSupplyType,
                vac_subsupplytype: this.state.formData.txtsubtype,
                vac_subsupplytypeother:
                  this.state.formData.cmbSubTypeOtherSpecify,
                vac_doctype: this.state.formData.CmbDocumentType,
                vac_docno: this.state.formData.txtDocumentNo,
                dat_docdate: this.state.formData.dtpDocumentDate,
                vac_transtype: this.state.formData.cmbTransactionType,
                vac_fromaddr1: this.state.formData.txtDispatchAddress1,
                vac_fromaddr2: this.state.formData.txtDispatchAddress2,
                vac_fromplace: this.state.formData.CmbDispatchPlace,
                vac_frompincode: this.state.formData.txtDispatchPincode,
                vac_fromstatecode: this.state.formData.txtCompanyStateCode,
                vac_fromstate: this.state.formData.CmbDispatchState,
                vac_actualfromstatecode:
                  this.state.formData.txtCompanyStateCode,
                vac_actualfromstate: this.state.formData.CmbDispatchState,
                vac_totrdname: this.state.formData.txtCustomerName,
                vac_togstin: this.state.formData.txtCustomerGSTNO,
                vac_toaddr1: this.state.formData.txtShipToAddress1,
                vac_toaddr2: this.state.formData.txtShipToAddress2,
                vac_toplace: this.state.formData.CmbShipToPlace,
                vac_topincode: this.state.formData.txtShipToPincode,
                vac_tostatecode: this.state.formData.txtCustomerStateCode,
                vac_tostate: this.state.formData.CmbShipToState,
                vac_actualtostatecode: this.state.formData.txtCustomerStateCode,
                vac_actualtostate: this.state.formData.CmbShipToState,
                dec_totalvalue: this.state.formData.txtTotalValue,
                dec_cgstvalue: this.state.formData.txtTotalCGST,
                dec_sgstvalue: this.state.formData.txtTotalSGST,
                dec_igstvalue: this.state.formData.txtTotalIGST,
                dec_cessvalue: 0,
                dec_totnonadvolval: 0,
                dec_othvalue: 0,
                vac_mainhsncode: this.state.formData.txtHsnCode,
                dec_totInvValue: this.state.formData.txtTotalInvoiceValue,
                vac_transmode: this.state.formData.CmbModeOfTransportation,
                dec_transdistance: this.state.formData.txtApproximateDistance,
                vac_transportername: this.state.formData.CmbTransporterName,
                vac_transporterid: this.state.formData.CmbTransporterID,
                vac_transdocno: this.state.formData.txtTransporterDocNo,
                dat_transdocdate: this.state.formData.dtpTransporterDate,
                vac_vehicleno: this.state.formData.CmbVehicleNo,
                vac_vehicletype: this.state.formData.CmbVehicleType,
              },
              SalesItemData: [],
            };
            fetchSales(reqData)
              .then((res) => {
                this.props.updateProcessing(res.data.msgType, res.data.message);
                if (res.data.msgType === "success") {
                  if (copyToClipBoard) {
                    this.GenerateEWay();
                  }
                  this.props.setEwayBillARDNull(res.data.EWayBillData);
                }
              })
              .catch((error) => {
                console.log("Unknown error occurred in saveEWayBill.", error);
              });
          });
        }
      });
    }
  };

  GenerateEWay = () => {
    const acid = localStorage.getItem("acid");
    const acYear = localStorage.getItem("ACY");
    const billNo = this.props.vac_billno;
    const editSalesSrNo = this.state.formData.bint_salessrno;
    const userId = localStorage.getItem("logInID");
    const userCi = localStorage.getItem("CI");
    const chkGetPincodeDistance = this.state.formData.chkGetPincodeDistance;
    // Build the data string
    const clipboardText = `"RTW_EWAY" "{"salesInfo":{"bint_acid":${acid},"bint_acyear":${acYear},"vac_billno":"${billNo}","edit_salessrno":${editSalesSrNo},"vac_userid":"${userId}","bint_ci":${userCi},"chkGetPincodeDistance":${chkGetPincodeDistance}}}"`;

    navigator.clipboard
      .writeText(clipboardText)
      .then(() => {
        this.props.updateProcessing(
          "success",
          "E-Way Bill data copied to clipboard!"
        );
        // alert("E-Way Bill data copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        this.props.updateProcessing("error", err);
      });
  };

  handleOpenValidVehicleNoFormat = () => {
    this.setState({
      openValidVehicleNoFormat: true,
    });
  };

  handleCloseValidVehicleNoFormat = () => {
    this.setState({
      openValidVehicleNoFormat: false,
    });
  };

  validVehicleList = (
    <table
      style={{
        borderCollapse: "collapse",
        width: "100%",
        marginTop: "10px",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
      }}
    >
      <thead>
        <tr style={{ backgroundColor: "#f2f2f2" }}>
          <th
            style={{
              border: "1px solid #ddd",
              padding: "8px",
              textAlign: "left",
            }}
          >
            Sr No.
          </th>
          <th
            style={{
              border: "1px solid #ddd",
              padding: "8px",
              textAlign: "left",
            }}
          >
            Valid Vehicle Number Format
          </th>
        </tr>
      </thead>
      <tbody>
        {[
          "KA12KA1234",
          "KA12K1234",
          "KA123456",
          "KAR1234",
          "KA123K1234",
          "KA12KAR1234",
          "DFXXXXXX",
          "TMXXXXXX",
          "BPXXXXXX",
          "NPXXXXXX",
        ].map((num, index) => (
          <tr key={index}>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {index + 1}
            </td>
            <td
              style={{
                border: "1px solid #ddd",
                padding: "8px",
                fontFamily: "monospace",
              }}
            >
              {num}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  //#endregion function

  render() {
    // console.log("this.props.CompanyDetails", this.props.CompanyDetails);
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Sales E-Way Bill</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={0}
          marginTop={0}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtTxt
                id="txtEWaybill"
                value={this.state.formData.txtEWaybill}
                label="E-Way Bill No."
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                width={110}
                disabled={true}
              />
            </Grid>
            {/* <Grid item> */}
            {/* <CtDtp
                id="DtpEWaybillDate"
                label="E-Way Bill Date"
                width="115"
                handleOnChange={this.handleOnChange}
                defaultValue={this.state.formData.DtpEWaybillDate}
                value={this.state.formData.DtpEWaybillDate}
                onKeyDown={this.props.onKeyDown}
                disabled={true}
                accountYear={localStorage.getItem("ACY")}
              /> */}

            {/* <MaterialUIPickers
                id="DtpEWaybillDate"
                label="E-Way Bill Date*"
                width={100}
                handleOnChange={this.handleOnChange}
                value={this.state.formData.DtpEWaybillDate}
                // onKeyDown={this.props.onKeyDown}
              /> */}
            {/* </Grid> */}
            <Grid item>
              <MaterialUIPickers
                id="DtpEWaybillDate"
                label="E-Way Bill Date"
                width={115}
                handleOnChange={this.handleOnChange}
                value={this.state.formData.DtpEWaybillDate}
                disabled={true}
                // onKeyDown={this.props.onKeyDown}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtSupplyType"
                value={this.state.formData.txtSupplyType}
                label="Supply Type"
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                width={100}
                disabled={true}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtsubtype"
                value={this.state.formData.txtsubtype}
                label="Sub Supply Type"
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                width={125}
                maxLength={100}
                disabled={true}
              />
            </Grid>
            {this.state.formData.txtsubtype == "Others" ? (
              <Grid item>
                <CtCmbEditable
                  id="cmbSubTypeOtherSpecify"
                  label="Sub Type Other Specify*"
                  items={this.state.SubSupplyTypeOther}
                  value={this.state.formData.cmbSubTypeOtherSpecify}
                  handleOnChange={this.handleOnChange}
                  width={225}
                  maxLength={100}
                  colID="vac_subsupplytypeother"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"CmbDocumentType"}
                  disabled={this.state.formData.txtsubtype !== "Others"}
                />
              </Grid>
            ) : (
              ""
            )}
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtCmb
                id="CmbDocumentType"
                value={this.state.formData.CmbDocumentType}
                label="Document Type*"
                handleOnChange={this.handleOnChange}
                items={this.state.DocumentType}
                width={190}
                maxLength={100}
                colID="vac_doctype"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"cmbTransactionType"}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtDocumentNo"
                value={this.state.formData.txtDocumentNo}
                label="Document No"
                handleOnChange={this.handleOnChange}
                width={150}
                maxLength={100}
                disabled={true}
              />
            </Grid>
            <Grid item>
              <CtDtp
                id="dtpDocumentDate"
                label="Document Date"
                width="150"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.dtpDocumentDate}
                onKeyDown={this.props.onKeyDown}
                accountYear={localStorage.getItem("ACY")}
                disabled={true}
              />
            </Grid>
            <Grid item>
              <CtCmb
                id="cmbTransactionType"
                value={this.state.formData.cmbTransactionType}
                label="Transaction Type*"
                handleOnChange={this.handleOnChange}
                items={this.state.TransactionType}
                width={200}
                maxLength={100}
                colID="vac_transtype"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"cmbTransactionType"}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtMultiLineText
                id="txtDispatchAddress1"
                label="Dispatch Address 1"
                value={this.state.formData.txtDispatchAddress1}
                handleOnChange={this.handleOnChange}
                width={355}
                onKeyDown={this.props.onKeyDown}
                maxLength={100}
              />
            </Grid>
            <Grid item>
              <CtMultiLineText
                id="txtDispatchAddress2"
                label="Dispatch Address 2"
                value={this.state.formData.txtDispatchAddress2}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                width={365}
                maxLength={100}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtCmbEditable
                id="CmbDispatchPlace"
                label="Dispatch Place"
                items={this.state.DispatchPlace}
                value={this.state.formData.CmbDispatchPlace}
                handleOnChange={this.handleOnChange}
                width={250}
                maxLength={100}
                colID="vac_fromplace"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"txtDispatchPincode"}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtDispatchPincode"
                value={this.state.formData.txtDispatchPincode}
                label="Dispatch Pincode*"
                handleOnChange={this.handleOnChange}
                width={225}
                maxLength={6}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"CmbDispatchState"}
              />
            </Grid>
            <Grid item>
              <CtCmbEditable
                id="CmbDispatchState"
                value={this.state.formData.CmbDispatchState}
                label="Dispatch State*"
                handleOnChange={this.handleOnChange}
                items={this.state.DispatchState}
                width={230}
                maxLength={100}
                colID="vac_state"
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtMultiLineText
                id="txtShipToAddress1"
                label="Ship To Address 1"
                value={this.state.formData.txtShipToAddress1}
                handleOnChange={this.handleOnChange}
                width={355}
                onKeyDown={this.props.onKeyDown}
                maxLength={100}
              />
            </Grid>
            <Grid item>
              <CtMultiLineText
                id="txtShipToAddress2"
                label="Ship To Address 2"
                value={this.state.formData.txtShipToAddress2}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                width={365}
                maxLength={100}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtCmbEditable
                id="CmbShipToPlace"
                label="Ship To Place"
                items={this.state.ShipToPlace}
                value={this.state.formData.CmbShipToPlace}
                handleOnChange={this.handleOnChange}
                width={250}
                maxLength={100}
                colID="vac_toplace"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"txtShipToPincode"}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtShipToPincode"
                value={this.state.formData.txtShipToPincode}
                label="Ship To Pincode*"
                handleOnChange={this.handleOnChange}
                width={225}
                maxLength={6}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"CmbShipToState"}
              />
            </Grid>
            <Grid item>
              <CtCmbEditable
                id="CmbShipToState"
                value={this.state.formData.CmbShipToState}
                label="Ship To State*"
                handleOnChange={this.handleOnChange}
                items={this.state.ShipToState}
                width={230}
                maxLength={100}
                colID="vac_state"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"CmbModeOfTransportation"}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtTxt
                id="txtTotalValue"
                value={this.state.formData.txtTotalValue}
                label="Total Value"
                handleOnChange={this.handleOnChange}
                width={110}
                onKeyDown={this.props.onKeyDown}
                disabled={true}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtTotalCGST"
                value={this.state.formData.txtTotalCGST}
                label="Total CGST"
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                width={115}
                disabled={true}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtTotalSGST"
                value={this.state.formData.txtTotalSGST}
                label="Total SGST"
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                width={100}
                disabled={true}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtTotalIGST"
                value={this.state.formData.txtTotalIGST}
                label="Total IGST"
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                width={125}
                disabled={true}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtTotalInvoiceValue"
                value={this.state.formData.txtTotalInvoiceValue}
                label="Total Invoice Value"
                handleOnChange={this.handleOnChange}
                width={225}
                onKeyDown={this.props.onKeyDown}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtCmb
                id="CmbModeOfTransportation"
                value={this.state.formData.CmbModeOfTransportation}
                label="Mode of Transportation*"
                handleOnChange={this.handleOnChange}
                items={this.state.ModeofTransportation}
                width={230}
                maxLength={100}
                colID="vac_transmode"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"txtApproximateDistance"}
              />
            </Grid>
            <Grid item marginTop={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="chkGetPincodeDistance"
                    checked={this.state.formData.chkGetPincodeDistance}
                    onChange={this.handleOnChkChange}
                  />
                }
                label="Get Pincode Distance"
              />
            </Grid>
            <Grid item>
              <CtTxtAmt
                id="txtApproximateDistance"
                label="Approximate Distance (in KM)*"
                value={this.state.formData.txtApproximateDistance}
                handleOnChange={this.handleOnChange}
                width={230}
                maxLength={10}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"CmbTransporterName"}
                disabled={this.state.formData.chkGetPincodeDistance}
              />
            </Grid>
            {/* <Grid item>
              <CtBtn
                label="Get Pincode Distance"
                onClick={this.getApproxDistance}
              />
            </Grid> */}
            <Grid item>
              <CtCmbEditable
                id="CmbTransporterName"
                value={this.state.formData.CmbTransporterName}
                label="Transporter Name"
                handleOnChange={this.handleOnChange}
                items={this.state.TransporterName}
                width={250}
                maxLength={100}
                colID="vac_transportername"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"CmbTransporterID"}
              />
            </Grid>
            <Grid item>
              <CtCmbEditable
                id="CmbTransporterID"
                value={this.state.formData.CmbTransporterID}
                label="Transporter ID*"
                handleOnChange={this.handleOnChange}
                items={this.state.TransporterID}
                width={154}
                maxLength={100}
                colID="vac_transporterid"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"txtTransporterDocNo"}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="txtTransporterDocNo"
                value={this.state.formData.txtTransporterDocNo}
                label="Trans.Doc No*"
                handleOnChange={this.handleOnChange}
                width={120}
                maxLength={100}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"dtpTransporterDate"}
              />
            </Grid>
            <Grid item>
              <CtDtp
                id="dtpTransporterDate"
                label="Transporter Date*"
                width="125"
                handleOnChange={this.handleOnChange}
                defaultValue={this.state.formData.dtpTransporterDate}
                value={this.state.formData.dtpTransporterDate}
                onKeyDown={this.props.onKeyDown}
                accountYear={localStorage.getItem("ACY")}
                nextCtrlID={"CmbVehicleNo"}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={0}
          >
            <Grid item>
              <CtCmbEditable
                id="CmbVehicleNo"
                value={this.state.formData.CmbVehicleNo}
                label="Vehicle No*"
                handleOnChange={this.handleOnChange}
                items={this.state.VehicleNo}
                width={200}
                maxLength={100}
                colID="vac_vehicleno"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"CmbVehicleType"}
              />
            </Grid>
            <Grid item marginTop={1}>
              <Button
                variant="outlined"
                startIcon={<Info />}
                onClick={this.handleOpenValidVehicleNoFormat}
              >
                Valid Vehicle No Formats
              </Button>
            </Grid>
            <Grid item>
              <CtCmb
                id="CmbVehicleType"
                value={this.state.formData.CmbVehicleType}
                label="Vehicle Type*"
                handleOnChange={this.handleOnChange}
                items={this.state.VehicleType}
                width={230}
                maxLength={100}
                colID="vac_vehicletype"
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            marginTop={1}
          >
            <Grid item>
              <CtBtn
                label="Save E-Way Bill Data"
                onClick={() => {
                  this.saveEWayBill(false);
                }}
              />
            </Grid>
            <Grid item>
              <CtBtn
                label="Generate E-Way Bill"
                onClick={() => {
                  this.saveEWayBill(true);
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>

          <Grid item>
            <Dialog
              open={this.state.openValidVehicleNoFormat}
              onClose={this.handleCloseValidVehicleNoFormat}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Valid E-Way Bill Vheicle No Formats"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {this.validVehicleList}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleCloseValidVehicleNoFormat}>
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(SalesE_WayBill)));
